import { render } from "./TopCoverHome.vue?vue&type=template&id=694a2079&scoped=true&ts=true"
import script from "./TopCoverHome.vue?vue&type=script&lang=ts"
export * from "./TopCoverHome.vue?vue&type=script&lang=ts"

import "./TopCoverHome.vue?vue&type=style&index=0&id=694a2079&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694a2079"]])

export default __exports__